import { Box, Link } from "@mui/material";

// Aviso fijo de ambiente de prueba, igual al de MatCon y Sumo Primero.
// Sobre móvil sube para no tapar botones flotantes; bajo los diálogos de MUI (1300).
export default function StagingBanner() {
  return (
    <Box
      role="note"
      sx={{
        position: "fixed",
        bottom: { xs: 96, md: 16 },
        left: "50%",
        transform: "translateX(-50%)",
        zIndex: 1250,
        maxWidth: 448,
        width: "calc(100% - 32px)",
        boxSizing: "border-box",
        bgcolor: "#facc15",
        color: "#713f12",
        fontSize: 14,
        lineHeight: 1.5,
        textAlign: "center",
        px: 2,
        py: 1.5,
        borderRadius: "16px",
        boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -4px rgba(0, 0, 0, 0.1)",
      }}
    >
      Este es un ambiente de prueba. Si buscas la web oficial, visita:{" "}
      <Link
        href="https://www.redfid.cl"
        target="_blank"
        rel="noopener noreferrer"
        sx={{ fontWeight: 600, color: "inherit", textDecorationColor: "inherit", "&:hover": { color: "#a16207" } }}
      >
        www.redfid.cl
      </Link>
    </Box>
  );
}
